import PocketBase from 'pocketbase';

import { clientEnv } from './client-env';

export const pocketBaseClient = new PocketBase(
  clientEnv.BUN_PUBLIC_POCKETBASE_URL
);

pocketBaseClient.autoCancellation(false);
